<style scope>
.w-80px {
    min-width: 80px !important;
}

.w-100px {
    min-width: 100px !important;
}

.w-150px {
    min-width: 150px !important;
}

.w-200px {
    min-width: 200px !important;
}

.w-250px {
    min-width: 250px !important;
}

.scroll-area {
    position: relative;
    margin: auto;
    width: 1200px;
    height: 300px;
}

.table-responsive {
    height: 390px;
}

#tblOrder.table>tbody>tr {
    height: 50px !important;
}
</style>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <div class="card-title h3 pb-2 mt-0">ค้นหา</div> -->
                        <form action="" class="" @submit.prevent="validateForm" novalidate ref="frmSubmit">
                            <div class="row d-flex align-items-end">

                                <!-- <FormInput name="AgentId" type="text" label="รหัสสมาชิก [เปิดให้แก้ไขชั่วคราว]" v-model="filter.AgentId"
                                    placeholder="รหัสสมาชิก" @validate="validate" :error="errors.AgentId" 
                                    :requireField="true" formGroupClass="form-group col-sm-3" /> -->


                                <FormDate name="DateStart" type="date" label="วันที่จ่ายเงิน" v-model="filter.DateStart"
                                    placeholder="วันที่จ่ายเงิน" @validate="validate" :error="errors.DateStart"
                                    :require-field="true" formGroupClass="form-group text-nowrap col-lg-2 offset-lg-2 col-md-6" />


                                <FormDate name="DateEnd" type="date" label="ถึงวันที่จ่ายเงิน" v-model="filter.DateEnd"
                                    placeholder="ถึงวันที่จ่ายเงิน" @validate="validate" :error="errors.DateEnd"
                                    :require-field="true" formGroupClass="form-group text-nowrap col-lg-2 col-md-6" />

                                <div class="form-group col">
                                    <button type="button" class="btn btn-primary" :disabled="isDownload"
                                        @click="submitReqSum" v-show="checkPermission(['ReadJob'])">
                                        <b-spinner v-if="isDownloadReqSum" small></b-spinner>
                                        <i v-else class="fe-search"></i>
                                        ค้นหา
                                    </button>
                                    <button type="button" class="btn btn-secondary ml-2" :disabled="isDownload"
                                        @click="submitDownload" v-show="checkPermission(['ReadJob'])">
                                        <b-spinner v-if="isDownload" small></b-spinner>
                                        <i v-else class="fe-download"></i>
                                        Download Excel
                                    </button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12 col-md-12 pb-0">
                                    <div class="d-flex flex-row justify-content-center">
                                        <b-form-radio v-model="filter.IsPendingStatus" value="N">
                                            เฉพาะงานที่อนุมัติแล้ว (วันที่ชำระเงิน)
                                        </b-form-radio>
                                        <b-form-radio v-model="filter.IsPendingStatus" value="Y"
                                            class="ml-4">
                                            เฉพาะงานที่อยู่ระหว่างดำเนินการ (วันที่แจ้งงาน)
                                        </b-form-radio>
                                        <b-form-radio v-model="filter.IsPendingStatus" value="NEW"
                                            class="ml-4">
                                            งานใหม่
                                        </b-form-radio>
                                        <b-form-radio v-model="filter.IsPendingStatus" value="UPLEVEL"
                                            class="ml-4">
                                            งานใหม่นับผลงาน
                                        </b-form-radio>
                                        <b-form-radio v-model="filter.IsPendingStatus" value="RENEW"
                                            class="ml-4">
                                            งานต่ออายุ
                                        </b-form-radio>
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-show="reqSumData.TotalSum != null">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive mb-1">
                                    <!-- Table -->
                                    <table id="tblOrder" class="table table-sm table-centered table-striped border mt-0"
                                        style="width: 1400px">
                                        <thead>
                                            <th class="text-center">ลำดับ</th>
                                            <!-- <th class="text-center">รหัสผู้แจ้งงาน</th> -->
                                            <th class="text-center">ตัวแทน</th>
                                            <th class="text-center">ประเภทงาน</th>
                                            <th class="text-center">สถานะงาน</th>
                                            <th class="text-center">เลขที่กรมธรรม์</th>
                                            <!-- <th class="text-center">แบบประกัน</th> -->
                                            <th class="text-center">บริษัทประกัน</th>
                                            <th class="text-center">ชื่อลูกค้า</th>
                                            <th class="text-center">เบี้ยประกันรวม</th>
                                            <th class="text-center">งวดการชำระเบี้ย</th>
                                            <th class="text-center">ปี/งวด ที่ชำระ</th>
                                            <!-- <th class="text-center">งวดที่ชำระ</th> -->
                                            <th class="text-center">
                                                {{ filter.IsPendingStatus == 'Y' ? 'วันที่แจ้งงาน' : 'วันที่ชำระเงิน' }}
                                            </th>
                                            <th class="text-center text-nowrap">วันที่ กธ. มีผลคุ้มครอง</th>
                                            <th class="text-center">อนุมัติยอดปรับระดับ</th>
                                            <!-- <th class="text-center">ผลประโยชน์ (หลังหักภาษี)</th> -->
                                            <!-- <th class="text-center">วันคืนผลประโยชน์</th> -->
                                            <!-- <th class="text-center text-wrap">ค่าบริหารทีมงาน</th> -->
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, idx) of Data" :key="idx">
                                                <td class="w-50px text-center">{{ idx + 1 }}</td>
                                                <td class="w-150px text-center"><div>{{ row.AgentId }}</div>{{ row.AgentTxt }}</td>
                                                <!-- <td class="w-200px text-center">{{ row.AgentTxt }}</td> -->
                                                <td class="w-80px text-center">{{ row.OrderType }}</td>
                                                <td class="w-80px text-center">{{ row.OrderStatus }}</td>
                                                <td class="w-100px text-center">{{ row.ContactPolicyNumber }}</td>
                                                <!-- <td class="w-100px text-center">{{ row.Plan }}</td> -->
                                                <td class="w-100px text-center">{{ row.InsuranceTxt }}</td>
                                                <td class="w-100px text-center">{{ row.Firstname }}</td>
                                                <td class="w-100px text-center">{{ moneyFormatFull(row.PaymentAmount) }}
                                                </td>
                                                <td class="w-100px text-center">{{ row.PaymentTypeTxt }}</td>
                                                <td class="w-100px text-center">{{ row.Year }}/{{ row.PaymentTime }}
                                                </td>
                                                <!-- <td>{{ row.PaymentTime }}</td> -->
                                                <td class="w-100px text-center">{{ dateFormat(row.CreatedAt) }}</td>
                                                <td class="w-100px text-center">{{ row.ContractSigned }}</td>
                                                <td class="w-100px text-center">{{ row.IsApproveUpLevel }}</td>
                                                <!-- <td class="w-100px text-center">{{ row.ComAfterTax }}</td> -->
                                                <!-- <td class="w-100px text-center">{{ row.CommissionAt ?
                                                    dateFormat(row.CommissionAt) : '' }}</td> -->
                                                <!-- <td class="w-80px text-center">
                                                    <button v-if="row.IsApproveUpLevel == 'Y'"
                                                        title="ตรวจสอบประโยชน์ค่าบริหารทีม"
                                                        @click="onReqTeamManagementBenefits(row)"
                                                        class="btn btn-sm btn-primary">ดู</button>
                                                </td> -->
                                            </tr>
                                            <tr v-if="!Data || Data.length === 0">
                                                <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- end table -->
                                </div>
                            </div>
                        </div>

                        <div class="row" v-show="reqSumData.TotalSum != null">
                            <div class="col-12 text-center p-0">
                                <table class="m-auto h4 text-primary" cellpadding="4">
                                    <tr>
                                        <th class="text-right">ยอดขายที่สามารถปรับระดับ</th>
                                        <td class="text-right">{{ moneyFormatFull(reqSumData.TotalAvaiUpLevel) }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-right">ยอดขายทั้งหมด</th>
                                        <td class="text-right">{{ moneyFormatFull(reqSumData.TotalSum) }}</td>
                                    </tr>
                                    <tr>
                                            <td class="text-left font-italic h5 pt-4 text-center" colspan="2">
                                               <hr>
                                                *** สำหรับงานที่ชำระเป็นรายงวด กรณีที่มีการอนุมัติปรับระดับแล้ว ยอดขายดังกล่าวจะนำไปคำนวณเป็นผลงานของเดือนที่มีการชำระเงินครั้งแรก<br />จึงอาจทำให้ยอดขายบางรายการไม่ปรากฏอยู่ในยอดขายรวมที่สามารถปรับระดับได้ตามรายงานฉบับนี้ ***</td>
                                            
                                        </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!-- 
        <b-modal size="lg" id="bv-modal-detail" hide-footer small>
            <template #modal-title>
                ตรวจสอบประโยชน์ค่าบริหารทีม
            </template>
            <div class="d-block">
                <b-alert variant="success" show class="mb-0">
                    <div class="row p-1 text-info">
                        <div class="col-md-2 h5 text-md-right">กรมธรรม์เลขที่:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.ContactPolicyNumber }}</div>
                        <div class="col-md-2 h5 text-md-right">ชื่อลูกค้า:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.Firstname }} {{ CurrData.Lastname }}</div>
                        <div class="col-md-2 h5 text-md-right">ชื่อบริษัทประกัน:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.InsuranceTxt }}</div>
                        <div class="col-md-2 h5 text-md-right">ชื่อสมาชิกที่แจ้ง:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.AgentId }} {{ CurrData.AgentTxt }}</div>
                    </div>
                </b-alert>

                <div class="row p-0 pt-0">
                    <div class="col-md-12">

                        <table class="table table-sm table-centered table-striped border mt-2">
                            <thead>
                                <tr>
                                    <th class="text-left">ระดับ</th>
                                    <th class="text-left">ชื่อตัวแทน</th>
                                    <th class="text-center">รหัสตัวแทน</th>
                                    <th class="text-right">ค่าบริหารทีม</th>
                                    <th class="text-center">วันที่จ่ายค่าบริหาร</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, idx) in DataTeamManagementBenefits" :key="idx"
                                    :class="{ 'text-warning': !row.Firstname }">
                                    <td>{{ row.CommissionLevel === 'ContractID' ? 'ผู้แนะนำ' : row.CommissionLevel }}</td>
                                    <td>{{ row.Firstname }} {{ row.Lastname }}</td>
                                    <td class="text-center">{{ row.AgentId }}</td>
                                    <td class="text-right">{{ moneyFormatFull(row.SumTotal) }}</td>
                                    <td class="text-center">{{ row.CommissionAt ? dateTimeFormat(row.CommissionAt,
                                        'DD-MM-YYYY') : '-' }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="5" class="text-center p-3 font-italic">แถบตัวอักษร <span
                                            class="text-warning">สีส้ม</span> หมายถึงผู้ที่ยังไม่สมัคร AML</th>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>

            </div>

        </b-modal> -->
    </Layout>
</template>
  
<script>
import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'

let self;
/**
 * Customers component
 */
export default {
    page: {
        title: 'รายงานยอดขาย(รวมทีมงาน)',
        meta: [{ name: 'description' }],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        var yup = this.yup
        return {
            title: 'รายงานยอดขาย(รวมทีมงาน)',
            items: [
                {
                    text: 'SKLife',
                    to: { name: 'home' }
                },
                {
                    text: 'รายงานยอดขาย(รวมทีมงาน)',
                    active: true
                },
            ],
            settings: {
                maxScrollbarLength: 600
            },

            VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
            isReqCmd: "",
            isDownload: false,
            isDownloadReqSum: false,
            reqSumData: {
                TotalSum: null,
                TotalAvaiUpLevel: null
            },

            Data: [],
            DataTeamManagementBenefits: [],
            CurrData: {},
            filter: {
                AgentId: "",
                DateStart: this.$dayjs().format('YYYY-MM-DD'),
                DateEnd: this.$dayjs().format('YYYY-MM-DD'),
                IsApprovedStatus: "Y",
                IsPendingStatus: "N",
                PerPage: 10,
                CurrentPage: 1,
            },
            errors: {
                AgentId: "",
                DateStart: "",
                DateEnd: "",
            },
            FormSchema: yup.object().shape({
                AgentId: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', AgentId => AgentId.length >= 4),
                DateStart: yup.string().required('กรุณาระบุวันที่จ่ายเงิน'),
                DateEnd: yup.string().required('กรุณาระบุวันที่จ่ายเงิน'),
            }),

        }
    },
    async created() {
        self = this;
        //this.$store.state.Admin.Id

        if (this.$store.state.Admin.IsForceChangePwd)
            this.$router.push({ name: 'admin-change-password' });
    },
    async mounted() {
        await this.getAgentId()
    },
    methods: {
        scrollHandle(evt) {
            console.log(evt)
        },
        submitReqSum() {
            console.log('submitDownload');
            self.isReqCmd = "REQSUM";
            this.validateForm();
        },
        submitDownload() {
            self.isReqCmd = "REQDOWNLOAD";
            this.validateForm();
        },
        validateForm() {
            this.FormSchema
                .validate(this.filter, { abortEarly: false })
                .then(() => {
                    if (self.isReqCmd == "REQDOWNLOAD")
                        this.downloadExcel(this.filter);
                    else if (self.isReqCmd == "REQSUM")
                        this.reqSum(this.filter);
                })
                .catch(err => {
                    err.inner.forEach(error => {
                        this.errors = { ...this.errors, [error.path]: error.message };
                    });
                });
        },
        validate(field) {
            this.FormSchema
                .validateAt(field, this.filter)
                .then(() => {
                    this.errors[field] = "";
                })
                .catch(err => {
                    this.errors[err.path] = err.message;
                });
        },
        async getAgentId() {
            this.isBusy = true
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
            };
            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/whtc/getagentid/' + this.$store.state.Admin.RefId, config)
                .then(function (res) {
                    if (res.status == 200) {
                        self.filter.AgentId = res.data;
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                    self.isBusy = false
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.isBusy = false
                });
        },
        downloadExcel(filter) {
            try {
                self.isDownload = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    responseType: 'blob',
                    params: filter
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/SalesReportByAgentIncludeTeam/download', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            const filename = `AgentOrderReport_${self.filter.AgentId}_${self.filter.DateStart}.xlsx`;
                            self.saveAs(res.data, filename);
                        } else {
                            self.$swal('เกิดข้อผิดพลาด1');
                        }
                        self.isDownload = false;
                    })
                    .catch(function (error) {
                        self.$swal('เกิดข้อผิดพลาด2');
                        self.isDownload = false;
                    });
            } catch (error) {
                return null
            }
        },
        reqSum(filter) {
            try {
                self.isDownloadReqSum = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    params: filter
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/SalesReportByAgentIncludeTeam', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            console.log(res.data);
                            self.reqSumData = res.data.Option;
                            self.Data = res.data.Data;
                        } else {
                            self.$swal('เกิดข้อผิดพลาด1');
                        }
                        self.isDownloadReqSum = false;
                    })
                    .catch(function (error) {
                        self.$swal('เกิดข้อผิดพลาด2');
                        self.isDownloadReqSum = false;
                    });
            } catch (error) {
                return null
            }
        },

        // onReqTeamManagementBenefits(row) {
        //     try {
        //         self.isDownloadReqSum = true;
        //         const config = {
        //             headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
        //             params: { ContractPolicyNumber: row.ContactPolicyNumber }
        //         };
        //         this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/TeamManagementBenefits', config)
        //             .then(function (res) {
        //                 if (res.status == 200) {
        //                     console.log(res.data);
        //                     self.DataTeamManagementBenefits = res.data.Data;
        //                     self.CurrData = row;
        //                     self.$bvModal.show('bv-modal-detail');

        //                 } else {
        //                     self.$swal('เกิดข้อผิดพลาด1');
        //                 }
        //                 self.isDownloadReqSum = false;
        //             })
        //             .catch(function (error) {
        //                 self.$swal('เกิดข้อผิดพลาด2');
        //                 self.isDownloadReqSum = false;
        //             });
        //     } catch (error) {
        //         return null
        //     }
        // },

    },
    watch: {
        'filter.AgentId': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };
            }
        },
        'filter.DateStart': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };
                
                if (this.filter.DateStart > this.filter.DateEnd)
                    this.filter.DateEnd = this.filter.DateStart;
            }
        },
        'filter.DateEnd': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };
                
                if (this.filter.DateStart > this.filter.DateEnd)
                    this.filter.DateStart = this.filter.DateEnd;
            }
        },

    }
}
</script>